import { Environment } from "./environment.model";

export const environment: Environment = {
  baseURL: "https://hom.gw.sgi.ms.gov.br/k0549/transpadm",
  baseURLRealMS:
    "https://hom.id.ms.gov.br/auth/realms/ms/protocol/openid-connect/token",
  client_id: "k0549",
  client_secret: "18000351-40c6-4168-a959-b679ad42cd5b",
  grant_type: "client_credentials",
};
